import { EnumLiteralsOf } from '../types/helpers'

export const SortKeys = {
  ALPHABETICAL: 'Alphabetically',
  DATE_LEAST_RECENT: 'Least recent',
  DATE_MOST_RECENT: 'Most recent',
} as const

export type SortKey = EnumLiteralsOf<typeof SortKeys>

export const sortOrder = {
  'Least recent': 'asc',
  'Most recent': 'desc',
} as const

export const NEW_PROJECT_ID = 'new'
export const CITATIONS_PER_PAGE = 500
